import type {
  AddUserToCompanyMutation,
  AddUserToCompanyMutationVariables
} from './__generated__/AddUserToCompanyMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import { userFragment } from '../fragments/UserFragment'

const mutation: TypedDocumentNode<
  AddUserToCompanyMutation,
  AddUserToCompanyMutationVariables
> = gql`
  ${userFragment}

  mutation AddUserToCompanyMutation(
    $input: AddUserToCompanyInput!
    $locale: String
  ) {
    addUserToCompany(input: $input) {
      user {
        ...UserFragment
      }
    }
  }
`

export function addUserToCompanyMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      AddUserToCompanyMutation,
      AddUserToCompanyMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
